/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DeleteCustomFieldDtoBase
 * auto generated base class for the model DeleteCustomFieldDtoModel.
 */
export const DeleteCustomFieldDtoModelBase = ModelBase
  .named('DeleteCustomFieldDto')
  .props({
    __typename: types.optional(types.literal("DeleteCustomFieldDto"), "DeleteCustomFieldDto"),
    wasDeleted: types.union(types.undefined, types.boolean),
    deletedName: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DeleteCustomFieldDtoModelSelector extends QueryBuilder {
  get wasDeleted() { return this.__attr(`wasDeleted`) }
  get deletedName() { return this.__attr(`deletedName`) }
}
export function selectFromDeleteCustomFieldDto() {
  return new DeleteCustomFieldDtoModelSelector()
}

export const deleteCustomFieldDtoModelPrimitives = selectFromDeleteCustomFieldDto().wasDeleted.deletedName
